import {
  ContractResponseDto,
  ContractResponseDtoContractStatusEnum,
  LayerResultsResponseDto,
  SubmissionResponseDto,
} from 'libs/pinnacle-sdk';

import {
  BinderPlacementFormValues,
  getBinderPlacementValidationSchemaShape,
  getInitialBinderPlacement,
} from './binder-placement/form';
import {
  getIncidentalValidationSchemaShape,
  getInitialIncidental,
  IncidentalFormValues,
} from './incidental/form';
import {
  getTransactionDetailInitialValues,
  getTransactionDetailsValidationSchemaShape,
  TransactionDetailsFormValues,
} from './transaction-details/form';

import { TFunction } from 'i18next';
import * as yup from 'yup';
import {
  ClosingReasonFormValues,
  getClosingReasonValidationSchemaShape,
  getInitialClosingReason,
} from './closing-reason/form';
import {
  getInitialNotesAndEndorsements,
  getNotesAndEndorsementsValidationSchemaShape,
} from './notes-and-endorsements/form';

export interface ContractDetailFormValues
  extends TransactionDetailsFormValues,
    IncidentalFormValues,
    BinderPlacementFormValues,
    ClosingReasonFormValues {
  notesAndEndorsements?: string;
}

// Combined initial values
export const getInitialValues = (
  submission: SubmissionResponseDto,
  contract?: ContractResponseDto,
  layerResult?: LayerResultsResponseDto
): ContractDetailFormValues => {
  return {
    ...getTransactionDetailInitialValues(submission, contract),
    ...getInitialIncidental(submission, contract),
    ...getInitialBinderPlacement(
      contract,
      contract?.totalTiv ?? submission.totalTivView?.totalTiv,
      layerResult
    ),
    ...getInitialClosingReason(contract),
    ...getInitialNotesAndEndorsements(contract),
  };
};

export const shouldShowDetailContent = (
  contractStatus: ContractResponseDtoContractStatusEnum
): boolean => {
  return contractStatus === ContractResponseDtoContractStatusEnum.Bound;
};

export const shouldShowClosingReason = (
  contractStatus: ContractResponseDtoContractStatusEnum
): boolean => {
  return (
    contractStatus === ContractResponseDtoContractStatusEnum.NotTakenUp ||
    contractStatus === ContractResponseDtoContractStatusEnum.Cancelled
  );
};

export const getValidationSchema = (
  t: TFunction,
  tbaConfig?: { tbaReinsuredIds?: string[]; tbaBrokerIds?: string[] }
) => {
  return yup.object().shape({
    ...getTransactionDetailsValidationSchemaShape(t, tbaConfig),
    ...getIncidentalValidationSchemaShape(t),
    ...getBinderPlacementValidationSchemaShape(t),
    ...getClosingReasonValidationSchemaShape(t),
    ...getNotesAndEndorsementsValidationSchemaShape(t),
  });
};
